module.exports = __webpack_public_path__ + "img/gld_gbt951_1986.prt.56b4d86b.jpg";